module.exports = __webpack_public_path__ + "img/background-branch-detail.eaa29c7d.svg";